import React, { useContext } from 'react';
import classnames from 'classnames';
import style from './Alamanac.module.scss';
import almanacImage from '../../assets/images/almanac.jpeg';

import AlmanacImage from '../icons/Almanac';
import { AlmanacShadow } from '../icons/Almanac';
import { getPriceBlock } from '../Price';
import { useSearchParams } from 'react-router-dom';
import { IOnePaymentItem, ModeEnum } from '../../model';
import { AlmanacContext } from '../../context/AlmanacContext';
import { ContainerQuery } from 'react-container-query';

interface IProps {
  oneTimePaymentItem?: IOnePaymentItem;
  currentPrice?: number;
  baseCheckoutPath: string;
  mode?: ModeEnum;
}

const query = {
  'small': {
    maxWidth: 899
  },
  'large': {
    minWidth: 900
  },
  'max-1600': {
    maxWidth: 1600
  },
  'max-1500': {
    maxWidth: 1500
  },
  'max-1100': {
    maxWidth: 1100
  },
  'max-1020': {
    maxWidth: 1020
  },
  'max-900': {
    maxWidth: 900
  },
  'max-768': {
    maxWidth: 768
  },
  'max-700': {
    maxWidth: 700
  },
  'max-650': {
    maxWidth: 650
  },
  'max-600': {
    maxWidth: 600
  },
  'max-550': {
    maxWidth: 550
  },
  'max-500': {
    maxWidth: 500
  },
  'max-425': {
    maxWidth: 425
  },
  'max-389': {
    maxWidth: 389
  }
};

const Almanac = ({oneTimePaymentItem, currentPrice, baseCheckoutPath, mode}: IProps) => {
  const context = useContext(AlmanacContext);

  if (!oneTimePaymentItem) return <></>;
  const basePrice = oneTimePaymentItem.base_price;

  const getActions = () => {
    return <div className={style.actions}>
      <a href={`${baseCheckoutPath}?otp_ids=[${oneTimePaymentItem.id}]`}
         className={classnames(style.button)}>
        Buy for {getPriceBlock(basePrice)}
      </a>
    </div>
  }


  return (
    <ContainerQuery query={query}>
      {(params) => {

        const classes = [];
        for(let key in params){
          if(params[key]) {
            classes.push(key)
          }
        }


        return (
          <div className={classnames(style.almanac_wrapper, {[style.widget]: mode === ModeEnum.widget}, params, classes.map(c => style[c]))}
               ref={context.ref}>
            <div className={classnames(style.oneTimeItem, style.almanac)}>
              <div className={style.oneTimeItem__content}>
                <hr className={style.delimer}/>
                <div className={style.text}>
                  Aaron Schatz's<br/>
                  <span className={style.name}>FTN Football Almanac 2024</span>
                  <AlmanacImage className={style.almanac_icon}/>
                  <AlmanacShadow className={classnames(style.almanac_icon, style.shadow)}/>
                </div>
                <div className={style.almanacImage__wrapper}>
                  <img src={almanacImage} alt="" className={style.almanacImage}/>
                  <div className={style.badge}>
                    <div className={style.price}>
                      {getPriceBlock(basePrice)}
                    </div>
                  </div>
                </div>

                {getActions()}

                <a className={classnames(style.button, style.blue, style.about)} href={'/almanac'}>
                  <span>About <i>Almanac</i></span>
                  <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.7031 5.12305L16.9305 10.3505L11.7031 15.5779" stroke="#00AEFF" strokeWidth="2"
                          strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16.2008 10.5234L1.80078 10.5234" stroke="#00AEFF" strokeWidth="2" strokeLinecap="round"
                          strokeLinejoin="round"/>
                  </svg>
                </a>
                <hr className={style.delimer}/>
              </div>
            </div>
          </div>
        )
      }}
    </ContainerQuery>
  );
};

export default Almanac;
